export const tr = {
  shiftCashPost: {
    shiftsAvailableForCheckoutH1: "Nakitleri Alınabilecek Vardiyalar",
    shiftsAvailableForDepositH1: "Bankaya Yatırılabilecek Vardiyalar",
    totalCashNotice: "Bankaya yatırılacak toplam nakit tutar: ",
    noShiftAvailable: "Vardiya bulunamadı.",
    paginationNext: "İleri",
    paginationPrev: "Geri",
    depositToBankButton: "Nakitleri Bankaya Götür",
    loadShifts: "Vardiyaları Yükle",
    printDepositButton: "Nakit Raporu Yazdır",
    loading: "Yükleniyor...",
    checkModal: {
      buttonText: "Bankaya Yatır",
      questionText:
        "Toplam nakiti bankaya yatırmak isteidğinizden emin misiniz?",
    },
    failedModal: {
      buttonText: "Tekrar Dene",
      questionText:
        "Sunucuya erişilemediğinden vardiyalar alınamadı. Tekrar denemek ister misiniz?",
    },
    depositPostFailedModal: {
      buttonText: "Tekrar Dene",
      questionText:
        "Sunucuya erişilemediğinden bankaya yatırılacak nakit kayıt edilemedi. Tekrar kayıt etmeyi denemek ister misiniz?",
    },
  },
  navigation: {
    home: "Ana Menü",
    login: "Giriş Yap",
    logout: "Çıkış Yap",
    cash: "Nakit",
    creditCard: "Kredi Kartı",
    shiftReview: "Vardiyalar",
    companyUsers: "Şirket Kullanıcıları",
    contact: "İletişim",
    about: "Hakkımızda",
    shiftReport: "Vardiya Raporu",
    admin: {
      title: "Yönetici",
      shifts: "Vardiyalar",
      deposits: "Kasa İşlemleri",
      creditCards: "Kredi Kartı İşlemleri",
      employeeDeficit: "Personel Açıkları",
      companyUsers: "Şirket Kullanıcıları"
    }
  },
  availableForCheckoutShift: {
    shiftId: "Vardiya Kimlik No",
    shiftDate: "Tarih",
    shiftNo: "Vardiya No",
    employeeName: "Personel",
    cash: "Nakit",
    note: "Not",
    totalCash: "Toplam Nakit",
    show: "Göster",
    hide: "Gizle",
    save: "Kaydet",
    loading: "Yükleniyor...",
    modalCheckButton: "Vardiyayı Kaydet",
    modalCheckQuestion: "Vardiyayı kayıt etmek istediğinize emin misiniz?",
    modalPostFailedButton: "Tekrar Dene",
    modalPostFailedQuestion:
      "Sunucuya erişilemediğinden vardiya kayıt edilemedi. Tekrar kayıt etmeyi denemek ister misiniz?",
  },
  shiftReview: {
    loading: "Yükleniyor...",
    table: {
      employeeName: "Personel Adı",
      totalSale: "Toplam Satış",
      deficit: "Açık",
      cashAmount: "Nakit Tutarı",
      creditCardAmount: "Kredi Kartı Tutarı",
      shiftId: "Vardiya No",
      totalEmployeeSale: "Toplam Personel Satışı",
      currentDeficit: "Mevcut Açık",
      totalCash: "Toplam Nakit",
      totalCreditCard: "Toplam Kredi Kartı"
    },
    buttons: {
      saveShift: "Vardiyayı Kaydet",
      enterCash: "Nakit Gir",
      enterCreditCard: "Kredi Kartı Gir",
      enterEmployeeCreditCard: "Personel Kredi Kartı Gir"
    },
    saving: "Kaydediliyor..."
  },
  shiftCreditCard: {
    availableShiftsH1: "Kredi Kartı Girişi Yapılabilecek Vardiyalar",
    noShiftAvailable: "Vardiya bulunamadı.",
    loadShifts: "Vardiyaları Yükle",
    loading: "Yükleniyor...",
    shiftId: "Vardiya No",
    date: "Tarih",
    shiftNo: "Vardiya No",
    bankName: "Banka Adı",
    batchNo: "Batch No",
    amount: "Tutar",
    show: "Göster",
    hide: "Gizle",
    save: "Kaydet",
    saving: "Kaydediliyor...",
    addNewBank: "Yeni Banka Ekle",
    buttons: {
      saveModal: {
        title: "Kredi Kartı Detaylarını Kaydet",
        question: "Kredi kartı detaylarını kaydetmek istediğinizden emin misiniz?",
        save: "Kaydet"
      },
      retryModal: {
        title: "Kayıt Başarısız",
        question: "Kayıt başarısız oldu, tekrar denemek ister misiniz?",
        retry: "Tekrar Dene"
      },
      addBankModal: {
        title: "Yeni Banka Ekle",
        question: "Eklemek istediğiniz bankayı seçin.",
        add: "Ekle"
      }
    },
    modal: {
      bank: {
        placeholder: "Banka Seçiniz",
        error: "Geçerli bir banka seçiniz."
      }
    }
  },
  general: {
    locale: 'tr',
    pagination: {
      next: "İleri",
      prev: "Geri"
    },
    modal: {
      retry: {
        title: "Tekrar Dene",
        question: "İşlem başarısız oldu, tekrar denemek ister misiniz?",
        button: "Tekrar Dene"
      },
      cancel: "İptal",
      totalCash: "Toplam Nakit:"
    }
  },
  employeeCreditCard: {
    addRow: "Satır Ekle",
    totalTransaction: "Toplam İşlem",
    alerts: {
      exceedAmount: "Toplam kredi kartı tutarını aşamazsınız"
    },
    table: {
      shiftId: "Vardiya No",
      shiftDate: "Vardiya Tarihi",
      shiftNo: "Vardiya No",
      totalCreditCardAmount: "Toplam Kredi Kartı Tutarı",
      totalEmployeeTransactions: "Toplam Personel İşlemleri",
      totalDifference: "Toplam Fark",
      bankName: "Banka Adı",
      batchNo: "Batch No",
      amount: "Tutar",
      employeeTransactions: "Personel İşlemleri",
      difference: "Fark"
    },
    buttons: {
      goToReview: "İncelemeye Git",
      saveAll: "Hepsini Kaydet",
      fetchAgain: "Tekrar Getir"
    },
    currentDeficit: "Mevcut Açık",
    warning: {
      title: "Uyarı!",
      message: "İşlemler başarıyla kaydedilemedi, tekrar denemek için lütfen \"Hepsini Kaydet\" butonuna tıklayın."
    },
    fetchFailed: "Getirme başarısız!",
    loading: "Yükleniyor..."
  },
  companyUser: {
    title: "Şirket Kullanıcı Yönetimi",
    addNewUser: "Yeni Kullanıcı Ekle",
    username: "Kullanıcı Adı",
    email: "E-posta",
    password: "Şifre",
    roles: "Roller",
    usersList: "Kullanıcı Listesi",
    status: {
      title: "Durum",
      active: "Aktif",
      inactive: "Pasif"
    },
    actions: "İşlemler",
    buttons: {
      save: "Kaydet",
      edit: "Düzenle",
      delete: "Sil"
    },
    firstName: "Ad",
    lastName: "Soyad",
    mobilePhone: "Telefon",
    editForm: {
      title: "Kullanıcı Düzenle",
      language: {
        title: "Tercih Edilen Dil",
        en: "İngilizce",
        tr: "Türkçe"
      },
      userStatus: "Kullanıcı Aktif",
      passwordPlaceholder: "Mevcut şifreyi korumak için boş bırakın"
    },
    alerts: {
      createSuccess: "Kullanıcı başarıyla oluşturuldu",
      updateSuccess: "Kullanıcı başarıyla güncellendi"
    },
  },
  validation: {
    required: 'Bu alan zorunludur',
    invalidEmail: 'Geçerli bir e-posta adresi giriniz',
    invalidPhone: 'Geçerli bir telefon numarası giriniz (05XX XXX XX XX)',
    roleRequired: 'En az bir rol seçilmelidir'
  },
  login: {
    title: "Hoş Geldiniz",
    subtitle: "Devam etmek için giriş yapın",
    username: "Kullanıcı Adı",
    password: "Şifre",
    signIn: "Giriş Yap",
    failed: "Giriş başarısız",
    success: "Giriş başarılı!"
  },
  home: {
    hero: {
      title: "Vardiyalarınızı Her Yerde Takip Edin",
      subtitle: "Akaryakıt istasyonu finansal yönetim uygulaması",
      getStarted: "Başlayın",
      learnMore: "Detaylı Bilgi",
      turpakCaption: "Turpak ile tam entegrasyon"
    },
    features: {
      title: "Neden Bizi Seçmelisiniz?",
      subtitle: "Akaryakıt istasyonu yönetimi için eksiksiz çözüm",
      turpakIntegration: {
        title: "TURPAK ile Tam Entegrasyon",
        description: "Gerçek zamanlı veri için TURPAK sistemi ile kusursuz senkronizasyon"
      },
      cashFlow: {
        title: "Nakit Akışı Yönetimi",
        description: "Nakit akışınızı hassasiyetle takip edin"
      },
      creditCard: {
        title: "Kredi Kartı Raporları",
        description: "Kapsamlı kredi kartı işlem yönetimi"
      },
      employeeManagement: {
        title: "Personel Yönetimi",
        description: "Verimli personel açık takibi ve yönetimi"
      }
    },
    workflow: {
      title: "Nasıl Çalışır",
      subtitle: "Basit ve etkili yönetim süreci",
      steps: [
        "TURPAK'tan satış verilerini al",
        "Ödemelerle karşılaştır",
        "Personel açıklarını takip et",
        "Ödemeleri doğrula",
        "Kesintileri yönet"
      ]
    },
    cta: {
      title: "Operasyonlarınızı düzenlemeye hazır mısınız?",
      subtitle: "İstasyonlarını verimli şekilde yöneten binlerce kullanıcıya katılın",
      button: "Ücretsiz Deneyin"
    }
  },
  contact: {
    title: "İletişime Geçin",
    subtitle: "Size nasıl yardımcı olabileceğimizi öğrenmek için formu doldurun",
    companyName: "Şirket Adı",
    fullName: "Ad Soyad",
    email: "E-posta",
    phone: "Telefon",
    message: "Mesajınız",
    submit: "Gönder",
    submitting: "Gönderiliyor...",
    successMessage: "Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.",
    errorMessage: "Bir hata oluştu. Lütfen daha sonra tekrar deneyin."
  },
  registration: {
    success: {
      message: "Kayıt başarılı! Giriş sayfasına yönlendiriliyorsunuz...",
      countdown: "{seconds} saniye içinde yönlendiriliyorsunuz...",
      invalidLink: "Geçersiz kayıt linki",
      loadError: "Kayıt detayları yüklenemedi",
      failed: "Kayıt başarısız. Lütfen tekrar deneyin."
    }
  },
  about: {
    hero: {
      title: "Akaryakıt İstasyonu Yönetiminizi Dönüştürün",
      subtitle: "Modern akaryakıt istasyonları için kapsamlı çözüm"
    },
    features: {
      turpak: {
        title: "TURPAK Entegrasyonu",
        realTime: "Gerçek Zamanlı Senkronizasyon",
        realTimeDesc: "TURPAK sistemleri ile anlık veri senkronizasyonu",
        reporting: "Otomatik Raporlama",
        reportingDesc: "Detaylı analiz ve içgörülerle kapsamlı raporlama sistemi"
      },
      cashFlow: {
        title: "Nakit Akışı Yönetimi",
        tracking: "Gerçek Zamanlı Takip",
        trackingDesc: "Nakit işlemlerini ve bakiyeleri anlık olarak izleyin",
        banking: "Banka Entegrasyonu",
        bankingDesc: "Sorunsuz banka yatırma takibi ve mutabakat"
      },
      creditCard: {
        title: "Kredi Kartı İşlemleri",
        processing: "İşlem Yönetimi",
        processingDesc: "Verimli kredi kartı işlem yönetimi ve takibi",
        mobile: "Mobil Destek",
        mobileDesc: "Mobil cihazlarla hareket halindeyken işlem yapabilme"
      },
      employee: {
        title: "Personel Yönetimi",
        shifts: "Vardiya Yönetimi",
        shiftsDesc: "Kapsamlı vardiya takip ve yönetim sistemi",
        performance: "Performans Takibi",
        performanceDesc: "Personel performansı ve işlem doğruluğu takibi"
      }
    },
    benefits: {
      title: "Neden Bizi Tercih Etmelisiniz?",
      efficiency: "Artan Verimlilik",
      efficiencyDesc: "Operasyonları düzenleyin ve manuel işleri azaltın",
      accuracy: "Daha İyi Doğruluk",
      accuracyDesc: "Otomatik sistemlerle hataları minimize edin",
      control: "Tam Kontrol",
      controlDesc: "Tüm operasyonlar üzerinde tam denetim"
    },
    cta: {
      title: "Operasyonlarınızı Optimize Etmeye Hazır mısınız?",
      subtitle: "Çözümümüzü kullanan önde gelen akaryakıt istasyonlarına katılın",
      button: "Hemen İletişime Geçin"
    }
  },
  admin: {
    shift: {
      title: "Vardiyalar",
      filters: {
        completed: "Tamamlandı",
        locked: "Kilitli",
        depositVerified: "Kasa Onaylandı",
        creditCardVerified: "Kredi Kartı Onaylandı",
        deficitDeducted: "Açık Düşüldü",
        deposited: "Kasaya Yatırıldı",
        filterActive: "Filtre Aktif",
        listAmount: "Liste Miktarı",
        search: "Ara"
      },
      table: {
        shiftId: "Vardiya No",
        completed: "Tamamlandı",
        locked: "Kilitli",
        depositVerified: "Kasa",
        creditCardVerified: "K. Kartı",
        deficitDeducted: "Açık",
        deficit: "Açık Tutarı",
        employeeSale: "Personel Satışı",
        cash: "Nakit",
        creditCard: "Kredi Kartı",
        partnerCard: "Partner Kart",
        giftCard: "Hediye Kartı",
        mobile: "Mobil",
        distributorSales: "Dağıtıcı Satışları",
        companySales: "Şirket Satışları",
        test: "Test",
        totalSale: "Toplam Satış"
      }
    },
    deposit: {
      title: "Kasa İşlemleri",
      filters: {
        filterActive: "Filtre Aktif",
        shiftLocked: "Vardiya Kilitli",
        shiftCompleted: "Vardiya Tamamlandı",
        deposited: "Bankaya Yatırıldı",
        depositVerified: "Yatırma Onaylandı",
        amount: "Tutar",
        active: "Aktif",
        dateFilter: "Tarih Filtresi",
        amountFilter: "Tutar Filtresi",
        shiftFilter: "Vardiya Filtresi",
        startDate: "Başlangıç Tarihi",
        startDateFilter: "Başlangıç Tarihi Filtresi",
        endDate: "Bitiş Tarihi",
        minAmount: "Min Tutar",
        searchByIdFilter: "Id'ye Göre Ara",
        firstShift: "İlk Vardiya",
        enterShiftId: "Vardiya No Giriniz",
        maxAmount: "Max Tutar",
        lastShift: "Son Vardiya",
        search: "Ara",
        sortBy: "Normal Sıralama",
        sortByDesc: "Ters Sıralama",
        listAmount: "Liste Miktarı",
        deleteMode: "Silme Modu",
        amountEqual: "Tutar Eşit",
        amountGreaterThanOrEqual: "Tutar Büyük Eşit",
        amountGreaterThan: "Tutar Büyük",
        amountLessThan: "Tutar Küçük",
        amountLessThanOrEqual: "Tutar Küçük Eşit"
      },
      table: {
        depositId: "Yatırma No",
        date: "Tarih",
        amount: "Tutar",
        deposited: "Yatırıldı",
        verified: "Onaylandı",
        deleteShift: "Vardiyayı Sil",
        showShift: "Vardiyayı Görüntüle",
        depositVerified: "Yatırma Onaylandı",
        totalAmount: "Toplam Tutar",
        eligibleForVerify: "Onaylanabilir",
        delete: "Sil",
        showCash: "Nakit Görüntüle",
        shiftId: "Vardiya No",
        locked: "Kilitli",
        completed: "Tamamlandı",
        yes: "Evet",
        no: "Hayır",
        employeeName: "Personel Adı",
        note: "Not",
        update: "Güncelle",
      }
    },
    creditCard: {
      title: "Kredi Kartı İşlemleri",
      noResults: "Kredi kartı işlemleri bulunamadı",
      filters: {
        filterActive: "Filtre Aktif",
        general: "Genel Filtreler",
        verified: "Onaylandı",
        locked: "Kilitli",
        completed: "Tamamlandı",
        bankFilter: "Banka Filtresi",
        bankFilterActive: "Banka Filtresi Aktif",
        shiftFilter: "Vardiya Filtresi",
        firstShift: "İlk Vardiya",
        lastShift: "Son Vardiya",
        search: "Ara",
        sortBy: "Normal Sıralama",
        sortByDesc: "Ters Sıralama",
        listAmount: "Liste Miktarı",
        amountFilter: "Tutar Filtresi",
        minAmount: "Minimum Tutar",
        maxAmount: "Maksimum Tutar",
        batchIdFilter: "Batch Id Filtresi",
        batchId: "Batch Id",
        searchByIdFilter: "Id'ye Göre Ara",
        selectBank: "Banka Seç"
      },
      table: {
        shiftId: "Vardiya No",
        bankName: "Banka",
        amount: "Tutar",
        batchId: "Batch No",
        locked: "Kilitli",
        completed: "Tamamlandı",
        verified: "Onaylandı",
        yes: "Evet",
        no: "Hayır"
      }
    },
  },
  shiftReport: {
    title: "Günlük Vardiya Raporu",
    selectDate: "Tarih Seçin",
    loading: "Yükleniyor...",
    noReports: "Seçilen tarih için vardiya raporu bulunamadı.",
    error: "Raporlar yüklenirken bir hata oluştu",
    shift: "Vardiya",
    shiftId: "Vardiya No",
    enterShiftId: "Vardiya No Giriniz",
    enterShiftIds: "Örn. 2025031101, 2025031102",
    multipleShiftIds: "Birden fazla vardiya no için virgülle ayırın",
    search: "Ara",
    totalSale: "Toplam Satış",
    noEmployeeData: "Personel verisi bulunamadı",
    noBatchData: "Kredi kartı batch verisi bulunamadı",
    descriptions: "Notlar",
    infoText: "Bilgi",
    exportExcel: "Excel'e Aktar",
    exportPDF: "PDF'e Dönüştür",
    shareLink: "Bağlantıyı Paylaş",
    linkCopied: "Bağlantı panoya kopyalandı!",
    clearDateFilter: "Tarih filtresini temizle",
    grandTotal: "Genel Toplam",
    employees: {
      title: "Personeller",
      name: "Personel",
      totalSale: "Toplam Satış",
      cashAmount: "Nakit Tutarı",
      creditCardAmount: "Kredi Kartı Tutarı",
      difference: "Fark",
      note: "Not",
      totals: "Toplamlar"
    },
    creditCardBatches: {
      title: "Kredi Kartı Batch",
      bank: "Banka",
      batchNo: "Batch No",
      amount: "Tutar",
      total: "Toplam"
    }
  },
  employeeDeficit: {
    title: "Personel Açıkları",
    filter: {
      title: "Filtrele",
      startShift: "Başlangıç Vardiyası",
      endShift: "Bitiş Vardiyası",
      deductionStatus: "Kesinti Durumu",
      allDeficits: "Tüm Açıklar",
      deducted: "Kesildi",
      notDeducted: "Kesilmedi",
      applyFilter: "Filtrele",
      resetFilter: "Sıfırla"
    },
    table: {
      shiftId: "Vardiya No",
      rootShiftId: "Ana Vardiya No",
      date: "Tarih",
      shiftNo: "Vardiya No",
      employee: "Personel",
      amount: "Tutar",
      status: "Durum",
      note: "Not",
      actions: "İşlemler"
    },
    status: {
      deducted: "Kesildi",
      notDeducted: "Kesilmedi"
    },
    buttons: {
      goToShift: "Vardiyaya Git",
      markAsDeducted: "Kesildi Olarak İşaretle",
      markAsNotDeducted: "Kesilmedi Olarak İşaretle"
    },
    confirmation: {
      title: "Onay",
      markAsDeducted: "Bu açığı kesildi olarak işaretlemek istediğinizden emin misiniz?",
      markAsNotDeducted: "Bu açığı kesilmedi olarak işaretlemek istediğinizden emin misiniz?",
      yes: "Evet",
      no: "Hayır"
    },
    noDeficits: "Personel açığı bulunamadı.",
    loading: "Yükleniyor..."
  }
};

export const eng = {
  shiftCashPost: {
    shiftsAvailableForCheckoutH1: "Shifts Available For Checkout",
    shiftsAvailableForDepositH1: "Shifts Available For Deposit",
    totalCashNotice: "Total cash going to be deposited to bank is: ",
    noShiftAvailable: "No shift available.",
    paginationNext: "Next",
    paginationPrev: "Prev",
    loadShifts: "Load Shifts",
    depositToBankButton: "Deposit Cash in The Bank",
    printDepositButton: "Print Deposit Report",
    loading: "Loading...",
    checkModal: {
      buttonText: "Deposit to bank",
      questionText: "Do you want to deposit the total cash in the bank?",
    },
    failedModal: {
      buttonText: "Retry",
      questionText: "Couldn't get shifts from server.",
    },
    depositPostFailedModal: {
      buttonText: "Retry",
      questionText:
        "The server could not be reached and therefore the shift was not saved. Would you like to try again?",
    },
  },
  navigation: {
    home: "Home",
    login: "Login",
    logout: "Logout",
    cash: "Cash",
    creditCard: "Credit Card",
    shiftReview: "Shifts",
    companyUsers: "Company Users",
    contact: "Contact",
    about: "About",
    shiftReport: "Shift Report",
    admin: {
      title: "Admin",
      shifts: "Shifts",
      deposits: "Cash Operations",
      creditCards: "Credit Card Operations",
      employeeDeficit: "Employee Deficits",
      companyUsers: "Company Users"
    }
  },
  modal: {
    totalCash: "Total cash:",
    retry: {
      title: "Retry",
      question: "Operation failed, would you like to try again?",
      button: "Retry"
    }
  },
  availableForCheckoutShift: {
    shiftId: "Shift Id",
    shiftDate: "Date",
    shiftNo: "Shift No",
    employeeName: "Employee",
    cash: "Cash",
    note: "Note",
    totalCash: "Total Cash",
    show: "Show",
    hide: "Hide",
    save: "Save",
    loading: "Loading...",
    modalCheckButton: "Save Shift",
    modalCheckQuestion: "Do you want to save the shift?",
    modalPostFailedButton: "Retry",
    modalPostFailedQuestion:
      "The server could not be reached and therefore the shift was not saved. Would you like to try again?",
  },
  shiftReview: {
    loading: "Loading...",
    table: {
      employeeName: "Employee Name",
      totalSale: "Total Sale",
      deficit: "Deficit",
      cashAmount: "Cash Amount",
      creditCardAmount: "Credit Card Amount",
      shiftId: "Shift Id",
      totalEmployeeSale: "Total Employee Sale",
      currentDeficit: "Current Deficit",
      totalCash: "Total Cash",
      totalCreditCard: "Total Credit Card"
    },
    buttons: {
      saveShift: "Save Shift",
      enterCash: "Enter Cash",
      enterCreditCard: "Enter Credit Card",
      enterEmployeeCreditCard: "Enter Employee Credit Card"
    },
    saving: "Saving..."
  },
  shiftCreditCard: {
    availableShiftsH1: "Shifts Available For Credit Card Save",
    noShiftAvailable: "No shifts available.",
    loadShifts: "Load Shifts",
    loading: "Loading...",
    shiftId: "Shift ID",
    date: "Date",
    shiftNo: "Shift No",
    bankName: "Bank Name",
    batchNo: "Batch No",
    amount: "Amount",
    show: "Show",
    hide: "Hide",
    save: "Save",
    saving: "Saving...",
    addNewBank: "Add New Bank",
    buttons: {
      saveModal: {
        title: "Save Credit Card Details",
        question: "Would you like to save the credit card details?",
        save: "Save"
      },
      retryModal: {
        title: "Save Failed",
        question: "Post failed, would you like to try again?",
        retry: "Retry"
      },
      addBankModal: {
        title: "Add New Bank",
        question: "Choose the bank you want to add.",
        add: "Add"
      }
    },
    modal: {
      bank: {
        placeholder: "Select Bank",
        error: "Choose valid bank."
      }
    }
  },
  general: {
    locale: 'en',
    pagination: {
      next: "Next",
      prev: "Prev"
    },
    modal: {
      retry: {
        title: "Retry",
        question: "Operation failed, would you like to try again?",
        button: "Retry"
      },
      cancel: "Cancel",
      totalCash: "Total Cash:"
    }
  },
  employeeCreditCard: {
    addRow: "Add Row",
    totalTransaction: "Total Transaction",
    alerts: {
      exceedAmount: "You can not exceed total credit card amount"
    },
    table: {
      shiftId: "Shift ID",
      shiftDate: "Shift Date",
      shiftNo: "Shift No",
      totalCreditCardAmount: "Total Credit Card Amount",
      totalEmployeeTransactions: "Total Employee Transactions",
      totalDifference: "Total Difference",
      bankName: "Bank Name",
      batchNo: "Batch No",
      amount: "Amount",
      employeeTransactions: "Employee Transactions",
      difference: "Difference"
    },
    buttons: {
      goToReview: "Go To Review",
      saveAll: "Save All",
      fetchAgain: "Fetch Again"
    },
    currentDeficit: "Current Deficit",
    warning: {
      title: "Warning!",
      message: "Transactions not saved successfully, if you want to try again please click \"Save All\" button."
    },
    fetchFailed: "Fetch failed!",
    loading: "Loading..."
  },
  companyUser: {
    title: "Company User Management",
    addNewUser: "Add New User",
    username: "Username",
    email: "Email",
    password: "Password",
    roles: "Roles",
    usersList: "Users List",
    status: {
      title: "Status",
      active: "Active",
      inactive: "Inactive"
    },
    actions: "Actions",
    buttons: {
      save: "Save",
      edit: "Edit",
      delete: "Delete"
    },
    firstName: "First Name",
    lastName: "Last Name",
    mobilePhone: "Mobile Phone",
    editForm: {
      title: "Edit User",
      language: {
        title: "Preferred Language",
        en: "English",
        tr: "Turkish"
      },
      userStatus: "User Enabled",
      passwordPlaceholder: "Leave empty to keep current password"
    },
    alerts: {
      createSuccess: "User created successfully",
      updateSuccess: "User updated successfully"
    },
  },
  validation: {
    required: 'This field is required',
    invalidEmail: 'Please enter a valid email address',
    invalidPhone: 'Please enter a valid phone number (05XX XXX XX XX)',
    roleRequired: 'At least one role must be selected'
  },
  login: {
    title: "Welcome Back",
    subtitle: "Please sign in to continue",
    username: "Username",
    password: "Password",
    signIn: "Sign In",
    failed: "Login failed",
    success: "Login successful!"
  },
  home: {
    hero: {
      title: "Track Your Shifts Anywhere",
      subtitle: "Oil station financial management application",
      getStarted: "Get Started",
      learnMore: "Learn More",
      turpakCaption: "Full integrity with Turpak"
    },
    features: {
      title: "Why Choose Us?",
      subtitle: "Complete solution for your oil station management needs",
      turpakIntegration: {
        title: "Full TURPAK Integration",
        description: "Seamless synchronization with TURPAK system for real-time data"
      },
      cashFlow: {
        title: "Cash Flow Management",
        description: "Track and manage your cash flow with precision"
      },
      creditCard: {
        title: "Credit Card Reports",
        description: "Comprehensive credit card transaction management"
      },
      employeeManagement: {
        title: "Employee Management",
        description: "Efficient employee deficit tracking and management"
      }
    },
    workflow: {
      title: "How It Works",
      subtitle: "Simple and effective management process",
      steps: [
        "Get sales data from TURPAK",
        "Compare with payments",
        "Track employee deficits",
        "Verify payments",
        "Manage deductions"
      ]
    },
    cta: {
      title: "Ready to streamline your operations?",
      subtitle: "Join thousands of satisfied users managing their stations efficiently",
      button: "Start Free Trial"
    }
  },
  contact: {
    title: "Contact Us",
    subtitle: "Fill out the form to learn how we can help you",
    companyName: "Company Name",
    fullName: "Full Name",
    email: "Email",
    phone: "Phone",
    message: "Message",
    submit: "Submit",
    submitting: "Submitting...",
    successMessage: "Your message has been sent successfully. We will get back to you soon.",
    errorMessage: "An error occurred. Please try again later."
  },
  registration: {
    success: {
      message: "Registration successful! Redirecting to login page...",
      countdown: "Redirecting in {seconds} seconds...",
      invalidLink: "Invalid registration link",
      loadError: "Failed to load registration details",
      failed: "Registration failed. Please try again."
    }
  },
  about: {
    hero: {
      title: "Transform Your Gas Station Management",
      subtitle: "Comprehensive solution for modern gas station operations"
    },
    features: {
      turpak: {
        title: "TURPAK Integration",
        realTime: "Real-Time Sync",
        realTimeDesc: "Instant synchronization with TURPAK systems for up-to-the-minute data accuracy",
        reporting: "Automated Reporting",
        reportingDesc: "Comprehensive reporting system with detailed analytics and insights"
      },
      cashFlow: {
        title: "Cash Flow Management",
        tracking: "Real-Time Tracking",
        trackingDesc: "Monitor cash transactions and balances in real-time",
        banking: "Bank Integration",
        bankingDesc: "Seamless bank deposit tracking and reconciliation"
      },
      creditCard: {
        title: "Credit Card Processing",
        processing: "Transaction Processing",
        processingDesc: "Efficient credit card transaction management and tracking",
        mobile: "Mobile Support",
        mobileDesc: "Process transactions on-the-go with mobile support"
      },
      employee: {
        title: "Employee Management",
        shifts: "Shift Management",
        shiftsDesc: "Comprehensive shift tracking and management system",
        performance: "Performance Tracking",
        performanceDesc: "Monitor employee performance and transaction accuracy"
      }
    },
    benefits: {
      title: "Why Choose Our Solution?",
      efficiency: "Increased Efficiency",
      efficiencyDesc: "Streamline operations and reduce manual work",
      accuracy: "Better Accuracy",
      accuracyDesc: "Minimize errors with automated systems",
      control: "Complete Control",
      controlDesc: "Full oversight of all operations"
    },
    cta: {
      title: "Ready to Optimize Your Operations?",
      subtitle: "Join the leading gas stations using our solution",
      button: "Contact Us Today"
    }
  },
  admin: {
    shift: {
      title: "Shifts",
      filters: {
        completed: "Completed",
        locked: "Locked",
        depositVerified: "Deposit Verified",
        creditCardVerified: "Credit Card Verified",
        deficitDeducted: "Deficit Deducted",
        deposited: "Deposited",
        filterActive: "Filter Active",
        listAmount: "List Amount",
        search: "Search"
      },
      table: {
        shiftId: "Shift ID",
        completed: "Completed",
        locked: "Locked",
        depositVerified: "Deposit",
        creditCardVerified: "CC",
        deficitDeducted: "Deficit",
        deficit: "Deficit Amount",
        employeeSale: "Employee Sale",
        cash: "Cash",
        creditCard: "Credit Card",
        partnerCard: "Partner Card",
        giftCard: "Gift Card",
        mobile: "Mobile",
        distributorSales: "Distributor Sales",
        companySales: "Company Sales",
        test: "Test",
        totalSale: "Total Sale"
      }
    },
    deposit: {
      title: "Deposits",
      filters: {
        dateFilter: "Date Filter",
        amountFilter: "Amount Filter",
        shiftFilter: "Shift Filter",
        startDate: "Start Date",
        endDate: "End Date",
        depositVerified: "Deposit Verified",
        creditCardVerified: "Credit Card Verified",
        filterActive: "Filter Active",
        shiftLocked: "Shift Locked",
        shiftCompleted: "Shift Completed",
        deposited: "Deposited",
        minAmount: "Min Amount",
        maxAmount: "Max Amount",
        firstShift: "First Shift",
        lastShift: "Last Shift",
        search: "Search",
        amountEqual: "Amount Equal to",
        active: "Active",
        amount: "Amount",
        amountGreaterThanOrEqual: "Amount Greater Than or Equal to",
        amountGreaterThan: "Amount Greater Than",
        amountLessThan: "Amount Less Than",
        amountLessThanOrEqual: "Amount Less Than or Equal to",
        startDateFilter: "Start Date Filter",
        searchByIdFilter: "Search By ID",
        enterShiftId: "Enter Shift ID",
        deleteMode: "Delete Mode",
        sortBy: "Normal Sort",
        sortByDesc: "Reverse Sort",
        listAmount: "List Amount",
      },
      table: {
        depositId: "Deposit ID",
        date: "Date",
        amount: "Amount",
        deposited: "Deposited",
        verified: "Verified",
        deleteShift: "Delete Shift",
        showShift: "Show Shift",
        depositVerified: "Deposit Verified",
        totalAmount: "Total Amount",
        eligibleForVerify: "Eligible for Verify",
        delete: "Delete",
        showCash: "Show Cash",
        shiftId: "Shift ID",
        locked: "Locked",
        completed: "Completed",
        yes: "Yes",
        no: "No",
        employeeName: "Employee Name",
        note: "Note",
        update: "Update"
      }
    },
    creditCard: {
      title: "Credit Card Transactions",
      noResults: "Couldn't find any credit cards.",
      filters: {
        filterActive: "Filter Active",
        general: "General Filters",
        verified: "Verified",
        locked: "Locked",
        completed: "Completed",
        bankFilter: "Bank Filter",
        bankFilterActive: "Bank Filter Active",
        shiftFilter: "Shift Filter",
        firstShift: "First Shift",
        lastShift: "Last Shift",
        search: "Search",
        sortBy: "Normal Sort",
        sortByDesc: "Reverse Sort",
        listAmount: "List Amount",
        amountFilter: "Amount Filter",
        minAmount: "Min Amount",
        maxAmount: "Max Amount",
        batchIdFilter: "Batch Id Filter",
        batchId: "Batch Id",
        searchByIdFilter: "Search By Id Filter",
        selectBank: "Select Bank"
      },
      table: {
        shiftId: "Shift ID",
        bankName: "Bank",
        amount: "Amount",
        batchId: "Batch No",
        locked: "Locked",
        completed: "Completed",
        verified: "Verified",
        yes: "Yes",
        no: "No"
      }
    },
    shiftReport: {
      title: "Daily Shift Report",
      selectDate: "Select Date",
      loading: "Loading...",
      noReports: "No shift reports found for the selected date.",
      error: "An error occurred while loading reports",
      shift: "Shift",
      shiftId: "Shift ID",
      enterShiftId: "Enter Shift ID",
      enterShiftIds: "e.g. 2025031101, 2025031102",
      multipleShiftIds: "Enter multiple IDs separated by comma",
      search: "Search",
      totalSale: "Total Sale",
      noEmployeeData: "No employee data available",
      noBatchData: "No credit card batch data available",
      descriptions: "Notes",
      infoText: "Info",
      exportExcel: "Export to Excel",
      exportPDF: "Export to PDF",
      shareLink: "Share Link",
      linkCopied: "Link copied to clipboard!",
      clearDateFilter: "Clear date filter",
      grandTotal: "Grand Total",
      employees: {
        title: "Employees",
        name: "Personnel",
        totalSale: "Total Sale",
        cashAmount: "Cash Amount",
        creditCardAmount: "Credit Card Amount",
        difference: "Difference",
        note: "Note",
        totals: "Totals"
      },
      creditCardBatches: {
        title: "Credit Card Batches",
        bank: "Bank",
        batchNo: "Batch No",
        amount: "Amount",
        total: "Total"
      }
    },
    employeeDeficit: {
      title: "Employee Deficits",
      filter: {
        title: "Filter",
        startShift: "Start Shift",
        endShift: "End Shift",
        deductionStatus: "Deduction Status",
        allDeficits: "All Deficits",
        deducted: "Deducted",
        notDeducted: "Not Deducted",
        applyFilter: "Filter",
        resetFilter: "Reset"
      },
      table: {
        shiftId: "Shift ID",
        rootShiftId: "Root Shift ID",
        date: "Date",
        shiftNo: "Shift No",
        employee: "Employee",
        amount: "Amount",
        status: "Status",
        note: "Note",
        actions: "Actions"
      },
      status: {
        deducted: "Deducted",
        notDeducted: "Not Deducted"
      },
      buttons: {
        goToShift: "Go To Shift",
        markAsDeducted: "Mark as Deducted",
        markAsNotDeducted: "Mark as Not Deducted"
      },
      confirmation: {
        title: "Confirm",
        markAsDeducted: "Are you sure you want to mark this deficit as deducted?",
        markAsNotDeducted: "Are you sure you want to mark this deficit as not deducted?",
        yes: "Yes",
        no: "No"
      },
      noDeficits: "No deficits found.",
      loading: "Loading..."
    }
  }
}
